import React from 'react';
import { Button } from 'antd';
import CommonListsIndex from '../../components/CommonLists/index';
import NewsList from './list';

class News extends CommonListsIndex {
  constructor() {
    super();
    this.api = 'news';
    this.addComponent = ``;
    this.editComponent = ``;
    this.listsComponent = NewsList;
    this.model_width = '90%';
  }
  componentDidMount() {
    this.queryList({ type: this.props.match.params.type });
    this.addComponent = `/content/news/${this.props.match.params.type}/add`;
    this.editComponent = `/content/news/${
      this.props.match.params.type
    }/id/edit`;
  }

  componentWillReceiveProps(nexrProps) {
    // 切换路由 type改变
    if (nexrProps.match.params.type !== this.props.match.params.type) {
      this.queryList({ type: nexrProps.match.params.type });
      this.addComponent = `/content/news/${nexrProps.match.params.type}/add`;
      this.editComponent = `/content/news/${
        nexrProps.match.params.type
      }/id/edit`;
    }
  }

  freshQueryList = () => {
    this.queryList({ type: this.props.match.params.type });
  };

  render() {
    const ListsComponent = this.listsComponent;
    return (
      <div>
        <div className="tantuer-op">
          <Button type="primary" icon="plus" onClick={this.add}>
            新增
          </Button>
        </div>

        <ListsComponent
          data={this.state.listsData}
          edit={this.edit}
          queryList={this.freshQueryList}
        />
      </div>
    );
  }
}
export default News;
